/**
 * MessageStrip designs.
 * @public
 */
enum MessageStripDesign {
	/**
	 * Message should be just an information
	 * @public
	 */
	Information = "Information",

	/**
	 * Message is a success message
	 * @public
	 */
	Positive = "Positive",

	/**
	 * Message is an error
	 * @public
	 */
	Negative = "Negative",

	/**
	 * Message is a warning
	 * @public
	 */
	Critical = "Critical",

	/**
	* Message uses custom color set 1
	* @public
	*/
	ColorSet1 = "ColorSet1",

	/**
	*  Message uses custom color set 2
	* @public
	*/
	ColorSet2 = "ColorSet2",
}

export default MessageStripDesign;
